<template>
  <select v-model="selected">
    <option :value="{
      fiscalYear: null,
      semester: null,
    }"></option>
    <option
      v-for="(yearSemester, index) of fiscalYearSemesters"
      :key="index"
      :value="yearSemester"
    >
        {{ `${yearSemester.fiscalYear} ${yearSemester.semester.name}` }}
    </option>
  </select>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator'
import _ from 'lodash';
import moment from 'moment';
import { Semester } from '@/store/master/types';
import { FiscalYearSemester } from '@/store/common.types'
import { RootState } from '@/store/types';

@Component
export default class FiscalYearSemesterInput extends Vue {
  @Prop() value!: FiscalYearSemester

  @Prop() initialSelected!: {
    fiscalYear: number,
    semesterCode: string,
  }

  private get semesters(): Semester[] {
    return (this.$store.state as RootState).master.semesters
  }

  private get fiscalYearSemesters(): FiscalYearSemester[] {
    const startYear = moment().get('year');
    const endYear = moment().add(2, 'years').get('year');
    const years = _.range(startYear, endYear, 1);

    if (_.isEmpty(this.semesters)) {
      return []
    }

    return _.chain(years)
      .map((year) => this.semesters.map((semester: Semester) => {
        return {
          fiscalYear: year,
          semester,
        }
      }))
      .flatten()
      .value()
  }

  private get selected(): FiscalYearSemester {
    return this.value
  }

  private set selected(fiscalYearSemseter: FiscalYearSemester) {
    if (_.isNull(fiscalYearSemseter.fiscalYear) && _.isNull(fiscalYearSemseter.semester)) {
      this.$emit('input', null)
    } else {
      this.$emit('input', fiscalYearSemseter)
    }
  }

  private mounted() {
    this.$store.dispatch('fetchMasterSemesters')
  }

  @Watch('fiscalYearSemesters')
  changedFiscaYearSemesters(fiscalYearSemesters: FiscalYearSemester[]) {
    if (!this.initialSelected) {
      return
    }

    this.selected = _.find(
      fiscalYearSemesters,
      ({ fiscalYear, semester }: FiscalYearSemester) => {
        return fiscalYear === this.initialSelected.fiscalYear
          && semester?.code === this.initialSelected.semesterCode
      },
    ) || {
      fiscalYear: null,
      semester: null,
    }
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
